import { PropsWithChildren } from 'react';

import { KaraokeAuthProvider } from '~/modules/Auth/KaraokeAuthProvider';
import { ErrorFallback } from '~/modules/Elements/ErrorFallback';
import LayoutWithBackgroundProvider from '~/modules/Elements/LayoutWithBackground';
import { KeyboardHelpProvider } from '~/routes/KeyboardHelp/Context';

import AppProviders from '../shared/AppProviders';

export default function KaraokeProviders({ children }: PropsWithChildren) {
  return (
    <AppProviders errorFallback={ErrorFallback}>
      <KaraokeAuthProvider>
        <LayoutWithBackgroundProvider>
          <KeyboardHelpProvider>{children}</KeyboardHelpProvider>
        </LayoutWithBackgroundProvider>
      </KaraokeAuthProvider>
    </AppProviders>
  );
}
